import logo from "assets/images/Cowva.svg";
import { Outlet } from "react-router-dom";

export default function UnauthenticatedLayout() {
  return (
    <div className="relative h-full w-full md:bg-[#D9D9D9] md:p-5 overflow-hidden">
      <img src={logo} alt="Cowva Logo" className="mb-5 z-20  md:flex " />
      <div
        className={`absolute left-1/2 transform -translate-x-1/2 h-[700px] w-[900px] bg-[#3897F0] rounded-full z-0 bottom-[-300px]`}
      ></div>
      <div className="relative w-full h-full flex justify-center items-center z-20">
        <div
          className="md:p-[50px] md:w-auto w-full md:h-auto h-full p-[30px] rounded-[10px] border border-[#DDD] bg-white shadow-[3.21px_3.21px_19.262px_rgba(69,69,69,0.05),_-3.21px_-3.21px_19.262px_rgba(75,75,75,0.05)]
"
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
